<template>
  <div v-if="offlineMode" class="container alert alert-info text-center mt-4 mb-0">
    <i class="fa fa-info-circle me-2"></i> <strong>You're in offline mode!</strong><br>
    In offline mode you can see <span class="font-bold">data stored in cache</span> and cannot interact with the app.<br>
    If you want to <span class="font-bold">load updated information</span> or if you need to <span class="font-bold">update your profile</span> or <span class="font-bold">request 
    a booking</span>, please <a href="#" @click="switchOffline" class="font-bold"><i class="fas fa-long-arrow-alt-right animate"></i> go online</a>.
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OfflineMode',
  computed: {
    ...mapGetters([
      'offlineMode',
      'testing'
    ])
  },
  methods: {
    switchOffline() {
      this.$store.dispatch('offline', !this.offlineMode)
      if (!this.offlineMode) {
        this.$router.go()
      }
    },
  }
}
</script>

<style></style>
